import { useScale } from "./src/use-scale.js";

export default useScale;
